/* ============================================
   HEADER — header.js
   Mega menu, search overlay, mobile drawer.
   ============================================ */

(function() {
  'use strict';

  /* ── Mega Menu ── */
  var megaWrap    = document.querySelector('[data-mega]');
  var triggers    = document.querySelectorAll('[data-mega-trigger]');
  var panels      = document.querySelectorAll('[data-mega-panel]');
  var overlay     = document.querySelector('[data-mega-overlay]');
  var hoverTimer  = null;

  function openPanel(name) {
    clearTimeout(hoverTimer);
    panels.forEach(function(p) { p.classList.remove('is-active'); });
    var target = document.querySelector('[data-mega-panel="' + name + '"]');
    if (target) {
      target.classList.add('is-active');
      megaWrap.classList.add('is-open');
    }
  }

  function closeAll() {
    hoverTimer = setTimeout(function() {
      panels.forEach(function(p) { p.classList.remove('is-active'); });
      megaWrap.classList.remove('is-open');
    }, 250);
  }

  triggers.forEach(function(el) {
    el.addEventListener('mouseenter', function() { openPanel(this.dataset.megaTrigger); });
    el.addEventListener('mouseleave', closeAll);
  });

  panels.forEach(function(el) {
    el.addEventListener('mouseenter', function() { clearTimeout(hoverTimer); });
    el.addEventListener('mouseleave', closeAll);
  });

  if (megaWrap) {
    megaWrap.addEventListener('mouseenter', function() { clearTimeout(hoverTimer); });
  }

  if (overlay) {
    overlay.addEventListener('click', function() {
      clearTimeout(hoverTimer);
      hoverTimer = null;
      panels.forEach(function(p) { p.classList.remove('is-active'); });
      if (megaWrap) megaWrap.classList.remove('is-open');
    });
  }

  /* ── Keyboard: close mega on Escape ── */
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') {
      clearTimeout(hoverTimer);
      panels.forEach(function(p) { p.classList.remove('is-active'); });
      if (megaWrap) megaWrap.classList.remove('is-open');
      closeMobileMenu();
      closeSearch();
    }
  });

  /* ── Search Overlay ── */
  var searchBtn   = document.querySelector('[data-search-open]');
  var searchWrap  = document.querySelector('[data-search]');
  var searchClose = document.querySelector('[data-search-close]');
  var searchInput = document.querySelector('[data-search-input]');
  var searchResults = document.querySelector('[data-search-results]');
  var searchTimer = null;

  function openSearch() {
    if (!searchWrap) return;
    searchWrap.classList.add('is-open');
    document.body.classList.add('is-scroll-locked');
    setTimeout(function() { if (searchInput) searchInput.focus(); }, 100);
  }

  function closeSearch() {
    if (!searchWrap) return;
    searchWrap.classList.remove('is-open');
    document.body.classList.remove('is-scroll-locked');
    if (searchInput) searchInput.value = '';
    if (searchResults) searchResults.innerHTML = '';
  }

  if (searchBtn) searchBtn.addEventListener('click', openSearch);
  if (searchClose) searchClose.addEventListener('click', closeSearch);

  /* Predictive search */
  if (searchInput && searchResults) {
    searchInput.addEventListener('input', function() {
      var query = this.value.trim();
      clearTimeout(searchTimer);
      if (query.length < 2) {
        searchResults.innerHTML = '';
        return;
      }
      searchTimer = setTimeout(function() {
        fetch('/search/suggest.json?q=' + encodeURIComponent(query) + '&resources[type]=product&resources[limit]=6')
          .then(function(r) { return r.json(); })
          .then(function(data) {
            var products = data.resources && data.resources.results && data.resources.results.products || [];
            if (products.length === 0) {
              searchResults.innerHTML = '<p class="lx-search__no-results">No results for "' + query + '"</p>';
              return;
            }
            var html = '';
            products.forEach(function(p) {
              var img = p.image ? '<img src="' + p.image + '" alt="">' : '';
              html += '<a href="' + p.url + '" class="lx-search__result-item">'
                + img
                + '<div><div class="lx-search__result-title">' + p.title + '</div>'
                + '<div class="lx-search__result-price">' + p.price + '</div></div>'
                + '</a>';
            });
            searchResults.innerHTML = html;
          })
          .catch(function() {
            searchResults.innerHTML = '';
          });
      }, 300);
    });
  }

  /* ── Mobile Menu ── */
  var mobileMenu = document.querySelector('[data-mobile-menu]');

  function openMobileMenu() {
    if (!mobileMenu) return;
    mobileMenu.classList.add('is-open');
    document.body.classList.add('is-scroll-locked');
  }

  function closeMobileMenu() {
    if (!mobileMenu) return;
    mobileMenu.classList.remove('is-open');
    document.body.classList.remove('is-scroll-locked');
  }

  document.querySelectorAll('[data-menu-open]').forEach(function(btn) {
    btn.addEventListener('click', openMobileMenu);
  });

  document.querySelectorAll('[data-menu-close]').forEach(function(btn) {
    btn.addEventListener('click', closeMobileMenu);
  });

  /* Mobile Accordions */
  document.querySelectorAll('[data-accordion]').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var wasOpen = this.classList.contains('is-open');

      /* Close all others first */
      document.querySelectorAll('[data-accordion]').forEach(function(other) {
        other.classList.remove('is-open');
        if (other.nextElementSibling) other.nextElementSibling.classList.remove('is-open');
      });

      /* Toggle clicked one */
      if (!wasOpen) {
        this.classList.add('is-open');
        if (this.nextElementSibling) this.nextElementSibling.classList.add('is-open');
      }
    });
  });

})();
